<template>
  <div class="flex flex-col justify-start items-start">
    <div
      v-for="(row, index) in filteredFields"
      :key="index"
      class="px-2 py-6 bg-white justify-start items-center gap-4 inline-flex border-racq-pale-blue-border"
      :class="index !== 0 ? 'border-t' : ''"
    >
      <div v-if="row.icon?.value?.src" class="flex items-center justify-center h-[72px] w-[72px]">
        <Image :media="row.icon" />
      </div>
      <div class="grow shrink basis-0 bg-white flex-col justify-start items-start gap-1 inline-flex">
        <RichText :field="row.title" class="text-racq-dark-grey text-lg-bold" />
        <RichText :field="row.text" class="text-racq-med-grey text-m" />
      </div>
    </div>
    <RichText :field="fields.footerText" class="text-racq-med-grey text-sm mt-2 md:mt-3" />
    <div class="mt-8 bg-racq-anti-flash-white h-8 w-full"></div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { RichText, Field, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

const props = defineProps<{
  fields: {
    fields: {
      title: Field<string>;
      text: Field<string>;
      icon: ImageField;
      showForPolicyTypes: { fields: { insuranceCoverageCode: Field<string> } }[];
    }[];
    footerText: Field<string>;
  };
  quoteType: string;
}>();

const filteredFields = computed(() =>
  props.fields.fields.filter((field) =>
    field.showForPolicyTypes.find((item) => item.fields.insuranceCoverageCode?.value === props.quoteType)
  )
);
</script>
